import React from 'react';
import Suggestions from 'design-system/suggestions/Suggestions';
const data = [
    {
        emoji: '📟',
        name: 'Tech',
    },
    {
        emoji: '👁️',
        name: 'Watching',
    },
    {
        emoji: '⭐',
        name: 'Favourites',
    },
    {
        emoji: '🔮',
        name: 'Future',
    },
    {
        emoji: '👀',
        name: 'Monitor',
    },
    {
        emoji: '📝',
        name: 'My List',
    },
    {
        emoji: '🌱',
        name: 'Green Energy',
    },
    {
        emoji: '⚡',
        name: 'High Growth',
    },
];
const WatchlistSuggestions = ({ name, suggestedData, handleSuggestionPress }) => (<Suggestions title="Suggestions" name={name} data={data} suggestedData={suggestedData} handleSuggestionPress={handleSuggestionPress}/>);
export default React.memo(WatchlistSuggestions);
